import videojs from 'video.js';

const arrowLeftSvg = '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 13L0.999999 7L7.5 1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const Component = videojs.getComponent('Component');

class NestedMenuWithAudiotracks extends Component {
  constructor(player, options) {
    super(player, options);
    this.handleBack = this.handleBack.bind(this);
    this.handleAudiotrack = this.handleClickByAudiotrack.bind(this);
    this.hide();
    this.on('click', this.handleBack);
    this.on('click', this.handleClickByAudiotrack);
  }

  show() {
    this.$('.vjs-settings-menu__nested-menu-content').innerHTML = this.getItemsHtml();
    super.show();
  }

  buildCSSClass() {
    return `vjs-settings-menu__nested-menu ${super.buildCSSClass()}`;
  }

  createEl() {
    const el = super.createEl('div', {
      className: this.buildCSSClass()
    });
    el.appendChild(
      super.createEl('button', {
        className: 'vjs-settings-menu__button-back',
        textContent: 'Назад'
      })
    ).insertAdjacentHTML('afterbegin', arrowLeftSvg);
    el.appendChild(
      super.createEl('div', {
        className: 'vjs-settings-menu__nested-menu-content'
      })
    );
    return el;
  }

  getItemsHtml() {
    const audiotracksSettings = this.player_.getChild('audiotracksSettings');
    if (!audiotracksSettings || audiotracksSettings.options_.audiotracksList.items.length <= 1) {
      return;
    }
    let html = '';
    const els = audiotracksSettings.$$('.vjs-audiotracks-settings-field');
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      const text = el.querySelector('label').innerText;
      const checked = el.querySelector('input').checked;
      const audiotrackId = el.querySelector('input').value;
      html += `<div>
        <input id="settings-menu__audiotracks_${i}" type="radio" name="settings-menu__audiotracks" value="${audiotrackId}" ${checked ? 'checked' : ''} />
        <label for="settings-menu__audiotracks_${i}" data-value="${audiotrackId}"><span class="vjs-settings-menu__nested-menu-point"></span><span class="vjs-settings-menu__nested-menu-label-text">${text}</span></label>
      </div>`;
    }
    return html;
  }

  handleBack(event) {
    const buttonBack = event.target.closest('.vjs-settings-menu__button-back');
    if (buttonBack) {
      const settingsMenu = this.player_.getChild('settingsMenu');
      videojs.dom.removeClass(
        settingsMenu.$('.vjs-settings-menu__content'),
        'vjs-hidden'
      );
      this.hide();
    }
  }

  handleClickByAudiotrack(event) {
    const labelEl = event.target.closest('label[for^="settings-menu__audiotracks_"]');
    if (labelEl) {
      const audiotrackId = labelEl.dataset.value;
      const audiotracksSettings = this.player_.getChild('audiotracksSettings');
      audiotracksSettings.$(`[value="${audiotrackId}"]`).checked = true;
      audiotracksSettings.options_.audiotracksList.play(audiotrackId);
      this.$('.vjs-settings-menu__button-back').click();
      this.player_.getChild('settingsMenu').hide();
    }
  }
}

Component.registerComponent('nestedMenuWithAudiotracks', NestedMenuWithAudiotracks);
